import { FormControl, InputLabel, Select } from "@mui/material"
import React from "react"

type Props = {
  value: any
  setValue: (value: any) => void
  placeholder: string | React.ReactNode
  children: React.ReactNode
}

const JoonSelectInput = ({ value, setValue, placeholder, children }: Props) => {
  return (
    <FormControl fullWidth size="small">
      {!value && placeholder && (
        <InputLabel
          shrink={false}
          id="categorySelect"
          className="joon-select-input-label"
        >
          {placeholder}
        </InputLabel>
      )}
      <Select
        className="joon-select-input"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        size="small"
        style={{ width: "100%" }}
      >
        {children}
      </Select>
    </FormControl>
  )
}

export default JoonSelectInput
